import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-session-refresh-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './session-refresh-dialog.component.html',
    standalone: false
})
export class SessionRefreshDialogComponent {
    private sanitizer = inject(DomSanitizer);

    showIframe = signal(false);
    loginUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.authControlService.getOidcAuthLoginUrl());

    constructor(public authControlService: AuthControlService) {
    }

    onLoad() {
        setTimeout(() => {
            this.showIframe.set(true);
        }, 2000)
    }
}
